"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiIntegrationsResponseToJSON = exports.CapiIntegrationsResponseFromJSONTyped = exports.CapiIntegrationsResponseFromJSON = exports.instanceOfCapiIntegrationsResponse = void 0;
var runtime_1 = require("../runtime");
var CapiIntegration_1 = require("./CapiIntegration");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the CapiIntegrationsResponse interface.
 */
function instanceOfCapiIntegrationsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCapiIntegrationsResponse = instanceOfCapiIntegrationsResponse;
function CapiIntegrationsResponseFromJSON(json) {
    return CapiIntegrationsResponseFromJSONTyped(json, false);
}
exports.CapiIntegrationsResponseFromJSON = CapiIntegrationsResponseFromJSON;
function CapiIntegrationsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'integrations': !(0, runtime_1.exists)(json, 'integrations') ? undefined : (json['integrations'].map(CapiIntegration_1.CapiIntegrationFromJSON)),
    };
}
exports.CapiIntegrationsResponseFromJSONTyped = CapiIntegrationsResponseFromJSONTyped;
function CapiIntegrationsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(CapiIntegration_1.CapiIntegrationToJSON)),
    };
}
exports.CapiIntegrationsResponseToJSON = CapiIntegrationsResponseToJSON;
